export enum SlideDirection {
  NONE = 'none',
  OUT = 'out',
  IN = 'in',
}
